export const REAUTHENTICATE_STATUS = {
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED',
};

export const REAUTHENTICATE_TOASTER_MESSAGES = {
    SELFIE_SUCCESS: 'Selfie matched successfully',
    SELFIE_FAILED: 'Selfie did not match. Please try again.',
    SELFIE_UNAVAILABLE: 'We could not start the selfie check. Please try again.',
    SELFIE_CHECK_FAILED: 'We could not check your selfie. Please try again.',
    CODE_SENT: 'Code resent',
};

// Re-auth session expires 7 minutes after the selfie flow starts.
export const REAUTHENTICATE_SESSION_TIMEOUT_MINUTES = 7;
